<template>
  <div>
    <div class="sepTop">
      <div v-for="item in items" :key="item.id">
        <gold-record-item :item="item" />
      </div>
    </div>
    <!-- <Empty :stat="loadStat" :icon="require('@/static/ic_charge_empty.png')" /> -->
    <van-empty
      class="custom-image"
      :image="require('@/static/ic_charge_empty.png')"
      description="暂无明细，赶快去充值一次吧"
      v-if="items.length === 0"
    />
  </div>
</template>

<script>
import Urls from '@/assets/js/Urls'
import http from '../../api/http'
import GoldRecordItem from './GoldRecordItem.vue'

export default {
  name: 'GoldRecord',
  components: {
    GoldRecordItem
  },
  data() {
    return {
      items: [],
      loadStat: 0
    }
  },
  mounted() {
    const url = Urls.DOMAIN_YKT + '/VCurrency/Recharge/RechargeRecords'
    this.loadStat = 0
    http.post(url, {}).then(
      response => {
        this.items = response.detail
        this.loadStat = this.items && this.items.length != 0 ? 2 : 1
      },
      response => {
        console.log('GoldRecord.vue 请求失败' + response)
      }
    )
  }
}
</script>
